var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-modal',{attrs:{"show":_vm.show,"options":{
    ..._vm.addSubcontractLabels,
    loading: this.creatingSubContract,
  },"size":"lg"},on:{"submit":_vm.createSubcontract,"close":function($event){return _vm.$emit('close')}}},[_c('PPMForm',{ref:"addSubcontractForm",attrs:{"mode":"subcontract","subcontractDetails":_vm.contractDetails},on:{"on-create-success":_vm.addNewSubcontractDataToTree}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }